import {ErrorHandler, Inject, Injectable, Injector, NgZone} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';

@Injectable()
export class AppErrorHandler extends ErrorHandler {
    private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;

    constructor(@Inject(NgZone) private ngZone: NgZone, @Inject(Injector) private injector: Injector, @Inject(Injector) private router: Router) {
        super();
    }

    // Need to get ToastrService from injector rather than constructor injection to avoid cyclic dependency error
    private get toastrService(): ToastrService {
        return this.injector.get(ToastrService);
    }

    public handleError(error: any): void {
        if (error instanceof HttpErrorResponse) {
            this.ngZone.run(() => {
                if (error.error.code === -2001) {
                    localStorage.removeItem(this.authLocalStorageToken);
                    document.location.reload();
                } else {
                    if (error.error.message) {
                        this.toastrService.error(error.error.message);
                    } else {
                        this.toastrService.error('Check your internet connection');
                    }
                }
            });
        }
        super.handleError(error);
    }
}
